<div
  class="tel-form"
  [formGroup]="telForm"
  [ngClass]="{ 'is-focused': isFocused() && appearance() !== 'outline' }"
>
  <mat-form-field
    [appearance]="appearance()"
    [subscriptSizing]="subscriptSizing()"
    class="prefix-form-field"
    matTooltip="{{ prefixCtrl.value?.name }}"
  >
    <mat-select
      formControlName="prefixCtrl"
      [placeholder]="(!isLoading() && codePlaceholder()) || ''"
      #singleSelect
      panelClass="tel-mat-select-panel"
      [required]="required()"
    >
      <mat-select-trigger>
        <div class="country-option">
          <div class="country-option-flag-container">
            @if (emojiFlags()) {
            <div>
              <span class="flag-emoji">{{ prefixCtrl.value?.emojiFlag }}</span>
            </div>
            } @else {
            <div class="country-option-flag" [ngClass]="prefixCtrl.value?.flagClass"></div>
            }
          </div>
          @if (includeDialCode() || prefixCtrl.value?.iso2 === 'mp') {
          <div>{{ prefixCtrl.value?.iso2?.toUpperCase() || '' }}</div>
          } @else {
          <div>+{{ prefixCtrl.value?.dialCode || '' }}</div>
          }
        </div>
      </mat-select-trigger>

      @if (enableSearch()) {
      <mat-option>
        <ngx-mat-select-search
          [formControl]="prefixFilterCtrl"
          [placeholderLabel]="searchPlaceholderLabel() || ''"
          [noEntriesFoundLabel]="noEntriesFoundLabel() || ''"
        >
          <svg
            ngxMatSelectSearchClear
            xmlns="http://www.w3.org/2000/svg"
            class="icon icon-tabler icon-tabler-x"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M18 6l-12 12" />
            <path d="M6 6l12 12" />
          </svg>
        </ngx-mat-select-search>
      </mat-option>
      } @for (country of filteredCountries | async; track $index) {
      <mat-option [value]="country">
        <div class="country-option" style="display: flex; align-items: center; font-size: 14px">
          <div class="country-option-flag-container">
            @if (emojiFlags()) {
            <div>
              <span class="flag-emoji">{{ country.emojiFlag }}</span>
            </div>
            } @else {
            <div class="country-option-flag" [ngClass]="country.flagClass"></div>
            }
          </div>
          <div>{{ country.name }}</div>
        </div>
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field
    [appearance]="appearance()"
    [subscriptSizing]="subscriptSizing()"
    class="number-form-field"
  >
    @if (label() ) {
    <mat-label>{{ label() }}</mat-label>
    }
    <input
      matInput
      type="tel"
      formControlName="numberControl"
      [placeholder]="prefixCtrl.value?.placeHolder || ''"
      autocomplete="off"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      [required]="required()"
      [attr.maxlength]="enableInputMaxLength() ? getMaxInputLength(prefixCtrl.value?.iso2) : null"
      #numberInput
      [maskito]="inputNumberMask"
    />

    @if (hasError) {
    <mat-error>{{ errorMessage }}</mat-error>
    }
  </mat-form-field>
</div>
